(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row-result/assets/javascripts/ball-row-result.js') >= 0) return;  svs.modules.push('/components/tur/ball-row-result/assets/javascripts/ball-row-result.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.result = svs.tur.ball.row.result || {};
const Events = svs.tur.ball.constants;
const Animations = svs.tur.ball.row.result.animations.Result;
class Default extends svs.tur.Base {
  constructor(options) {
    const {
      row = svs.tur.ball.Row
    } = options;
    options = _objectSpread(_objectSpread({}, options), {}, {
      centered: false,
      row,
      className: 'ball-row-result'
    });
    super(options);
    this.row = row;
    this.on(Events.SORT_COMPLETED, this.spinNext, this);
    this.on(Events.RESULT_SKIPPED, this.resultCompleted, this);
    this.on(Events.CORRECTION_PAUSE, this.correctionPause, this);
    this.on(Events.CORRECTION_PLAY, this.correctionPlay, this);
  }
  classNames() {
    return ['ball-row-result-default'];
  }
  render() {
    let visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    this.$el.appendChild(this.row.render(visible));
    if (this.extraNumbersTitle) {
      this.$title = this.createElement('subtitle');
      this.$title.innerText = this.extraNumbersTitle;
      const $ballsExtra = this.$el.querySelector('.ball-row-numbers-extra');
      const $ballsNumbers = $ballsExtra.parentNode;
      $ballsNumbers.insertBefore(this.$title, $ballsExtra);
    }
    if (!visible) {
      this.$el.style.opacity = 0;
    }
    return this.$el;
  }
  spin() {
    let speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if (!this.$el) {
      return;
    }
    if (!this.tl) {
      const tl = gsap.timeline({
        onStart: () => {
          this.trigger(Events.RESULT_STARTED, this);
        },
        onComplete: () => {
          this.resultCompleted();
        },
        paused: true
      });
      tl.set([this.$el, this.row.$el], {
        opacity: 1
      });
      this.row.balls.forEach(ball => {
        tl.add(Animations.spin(ball, speed)).addPause();
        ball.on(Events.BALL_RESULT_REVEALED, ballRevealed => {
          this.trigger(Events.BALL_RESULT_REVEALED, ballRevealed);
        });
      });
      tl.play();
      this.tl = tl;
    } else {
      this.tl.progress(0, true).play();
    }
    return this.tl;
  }
  spinNext() {
    var _this$tl;
    (_this$tl = this.tl) === null || _this$tl === void 0 || _this$tl.play();
  }
  skip(skipKungKeno) {
    if (this.tl && this.tl.progress() < 1) {
      this.tl.totalProgress(1, true);
    } else {
      this.spin(); 
      this.tl.totalProgress(1, true);
    }
    this.trigger(Events.RESULT_SKIPPED, skipKungKeno);
  }
  destroy() {
    if (this.tl) {
      this.tl.clear();
      this.tl.kill();
      this.tl = null;
    }
    this.$el = null;
    super.destroy();
  }
  correctionPause() {
    var _this$kungKenoTtimeLi, _this$tl2;
    (_this$kungKenoTtimeLi = this.kungKenoTtimeLine) === null || _this$kungKenoTtimeLi === void 0 || _this$kungKenoTtimeLi.pause();
    (_this$tl2 = this.tl) === null || _this$tl2 === void 0 || _this$tl2.pause();
  }
  correctionPlay() {
    var _this$kungKenoTtimeLi2, _this$tl3;
    (_this$kungKenoTtimeLi2 = this.kungKenoTtimeLine) === null || _this$kungKenoTtimeLi2 === void 0 || _this$kungKenoTtimeLi2.play();
    (_this$tl3 = this.tl) === null || _this$tl3 === void 0 || _this$tl3.play();
  }
  resultCompleted() {
    this.trigger(Events.RESULT_REVEALED, this);
  }
  sort(order) {
    this.row.sort(order);
  }
  hideNumbers() {
    this.row.hideNumbers();
  }
  animateIn() {
    let delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    const tl = gsap.timeline({
      delay,
      onComplete: () => {
        this.trigger(Events.ANIMATION_COMPLETED, this);
      }
    });
    tl.set([this.$el, this.row.$el], {
      opacity: 1
    });
    _.shuffle(this.row.balls).forEach(ball => {
      tl.fromTo(ball.$el, {
        opacity: 0,
        scale: 0.3
      }, {
        duration: 0.2,
        opacity: 1,
        scale: 1,
        ease: 'back.out'
      }, '-=.15');
    });
    return tl;
  }
  finish() {
    this.row.balls.forEach(ball => {
      ball.animations.result.skip();
    });
    this.trigger(Events.RESULT_REVEALED, this);
    this.trigger(Events.RESULT_RENDERED, this);
  }
}
svs.tur.ball.row.result.Default = Default;

 })(window);